import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy-link',
  template: `
    <a 
      (click)="navigateToPrivacyPolicy()" 
      class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline cursor-pointer transition-colors duration-200"
      [class]="customClass"
    >
      {{ linkText }}
    </a>
  `,
  styleUrls: []
})
export class PrivacyLinkComponent {
  @Input() linkText: string = 'Aviso de Privacidad';
  @Input() customClass: string = '';

  constructor(private router: Router) {}

  navigateToPrivacyPolicy(): void {
    this.router.navigate(['/privacy-policy']);
  }
}